import React, { useState } from "react"
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Table,
} from "reactstrap"
import plusIcon from "../../assets/icons/plusIcon.svg"
import minusIcon from "../../assets/icons/minusIcon.svg"
import NumberFormat from "../../utils/numberFormat"
import UpdateTable from "./UpdatedTable"
import arrow from "../../assets/icons/arrow.svg"
import { useNavigate } from "react-router-dom"

const NestedAccordion = ({
  data = [],
  parentKey = "root",
  startDate,
  endDate,
  menuLabell,
}) => {
  const [open, setOpen] = useState("")

  const toggle = id => {
    setOpen(open === id ? "" : id)
  }

  const navigate = useNavigate()

  const desimalrange = localStorage.getItem("desimalrange")

  const assetColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance-ledger-acc`, {
              state: { item, startDate, endDate, menuLabell },
            })
          }
          className="pointer fw-bold ps-3"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.debit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.debit) > Number(item?.credit)
                    ? Number(item?.debit) - Number(item?.credit)
                    : 0
                ),
                desimalrange || 2,
                desimalrange || 2
              )}`
            : "-"}
        </div>
      ),
    },
    {
      label: "",
      renderCell: item => (
        <div className="fw-500 fs-14 text-end pe-5">
          {item?.credit
            ? `${NumberFormat(
                Math.abs(
                  Number(item?.credit) > Number(item?.debit)
                    ? Number(item?.credit) - Number(item?.debit)
                    : 0
                ),
                desimalrange || 2,
                desimalrange || 2
              )}`
            : "-"}
        </div>
      ),
    },
  ]

  return (
    <Accordion open={open} toggle={toggle}>
      {data?.map((item, index) => {
        const currentKey = `${parentKey}-${index}`
        const isOpen = open === currentKey

        return (
          <AccordionItem key={item.id || currentKey}>
            <AccordionHeader
              targetId={currentKey}
              className="d-flex align-items-center w-100 pointer custom-header-accordion py-0"
            >
              {/* Column 1: Icon + Group Name */}
              <div className="w-50 d-flex align-items-center">
                <img
                  src={isOpen ? minusIcon : plusIcon}
                  alt={isOpen ? "Collapse" : "Expand"}
                  style={{ width: "8px", height: "8px", marginRight: "4px" }}
                />
                {item.group_name}
              </div>

              {/* Column 2: Debit */}
              <div className="w-25 pe-5 text-end">
                {item?.debit
                  ? `${NumberFormat(
                      Math.abs(
                        Number(item?.debit) > Number(item?.credit)
                          ? Number(item?.debit) - Number(item?.credit)
                          : 0
                      ),
                      desimalrange,
                      desimalrange
                    )}`
                  : "-"}
              </div>

              {/* Column 3: Credit */}
              <div className="w-25 pe-5 text-end">
                {item?.credit
                  ? `${NumberFormat(
                      Math.abs(
                        Number(item?.credit) > Number(item?.debit)
                          ? Number(item?.credit) - Number(item?.debit)
                          : 0
                      ),
                      desimalrange,
                      desimalrange
                    )}`
                  : "-"}
              </div>
            </AccordionHeader>

            <AccordionBody accordionId={currentKey} className="py-0">
              {/* Ledgers Table */}
              {item.ledgers?.length > 0 && (
                // <Table bordered size="sm">
                //   <tbody>
                //     {item.ledgers.map((ledger) => (
                //       <tr key={ledger.id}>
                //         <td style={{ width: "50%" }}>{ledger.ledger_name}</td>
                //         <td style={{ width: "25%", textAlign: "right" }}>
                //           {ledger.debit.toLocaleString()}
                //         </td>
                //         <td style={{ width: "25%", textAlign: "right" }}>
                //           {ledger.credit.toLocaleString()}
                //         </td>
                //       </tr>
                //     ))}
                //   </tbody>
                // </Table>
                <UpdateTable
                  //   className="mt-2"
                  nodes={item.ledgers}
                  columns={assetColumns}
                  handilpagedrop={false}
                  tableWidth="50% 25% 25%"
                  mobileWidth="50% 25% 25%"
                  headerHide={true}
                />
              )}

              {/* Recursive sub-groups */}
              {item.sub_groups?.length > 0 && (
                <NestedAccordion
                  data={item?.sub_groups}
                  parentKey={currentKey}
                />
              )}
            </AccordionBody>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default NestedAccordion
